export enum MigrationRequestEnum {
  MigrateAll = 'MigrateAll',
  MigrateSome = 'MigrateSome',
  MigrateNone = 'MigrateNone'
}
